import React from 'react';
import {
  StyledAboutEducation,
  StyledAccordion,
  StyledBody,
  StyledDescription,
  StyledTitle,
  StyledYear,
} from './styles';
import {AboutEducationArtistPageProps} from './typings';

const Education = ({education}: AboutEducationArtistPageProps) => {
  return (
    <>
      {education?.map((item, index) => (
        <React.Fragment key={`education-${index}`}>
          <StyledYear>{item.years}</StyledYear>

          <StyledDescription>{item.school}</StyledDescription>
        </React.Fragment>
      ))}
    </>
  );
};

const AboutEducationArtistPage = ({
  education,
  className,
}: AboutEducationArtistPageProps): JSX.Element | null => {
  const title = 'Education';

  return education?.length ? (
    <>
      <StyledAboutEducation className={className}>
        <StyledTitle>{title}</StyledTitle>

        <StyledBody>
          <Education education={education} />
        </StyledBody>
      </StyledAboutEducation>

      <StyledAccordion title={title} strongTitle={false} className={className}>
        <Education education={education} />
      </StyledAccordion>
    </>
  ) : null;
};

export default AboutEducationArtistPage;
